module.exports = __webpack_public_path__ + "static/media/sa.199b2347.svg";